export default __webpack_public_path__ + "static/media/factura.c60eb9fe.png";